module.exports = __webpack_public_path__ + "media/images/emblems/Eriz-coat_of_arms-2ab0224b172c1318479c0db88f0ee779.svg";